// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Bq3S","row":"Node_row__2lUUk","label":"Node_label__28Bks","footer":"Node_footer__1NPaC"};